import template from "./dialog-config.html";
import css from "./dialog-config.css";
import Dialog from "dialog";
import sleep from "sleep";


class ConfigEZOPHDialog extends Dialog {
	static get template() {
		return template;
	}
	static get css() {
		return css;
	}
	static constructor() {
		customElements.define("fulljs-dialog-config-ezoph", ConfigEZOPHDialog);
	}
	constructor() {
		super();

		document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

		this.onupdatedevices_handler({detail: application.devices});

		this.show();
	}
	async buttonClearCalibration_click() {
      try {
        this.buttonClearCalibration.style.pointerEvents = "none";
        this.buttonClearCalibration.icon.iconname = "view-refresh";
        await server.rcall("RM_ezoph_clearCalibration");
        this.buttonClearCalibration.icon.iconname = "dialog-ok-apply";
      } catch(e) {
        this.buttonClearCalibration.icon.iconname = "process-stop";
      } finally {
        await sleep(3000);
        this.buttonClearCalibration.icon.iconname = "dialog-ok";
        this.buttonClearCalibration.style.pointerEvents = "";
      }
	}
	async buttonCalibrateTo7_click() {
      try {
        this.buttonCalibrateTo7.style.pointerEvents = "none";
        this.buttonCalibrateTo7.icon.iconname = "view-refresh";
        await server.rcall("RM_ezoph_calibrateTo7");
        this.buttonCalibrateTo7.icon.iconname = "dialog-ok-apply";
      } catch(e) {
        this.buttonCalibrateTo7.icon.iconname = "process-stop";
      } finally {
        await sleep(3000);
        this.buttonCalibrateTo7.icon.iconname = "dialog-ok";
        this.buttonCalibrateTo7.style.pointerEvents = "";
      }
	}
	async buttonCalibrateTo4_click() {
      try {
        this.buttonCalibrateTo4.style.pointerEvents = "none";
        this.buttonCalibrateTo4.icon.iconname = "view-refresh";
        await server.rcall("RM_ezoph_calibrateTo4");
        this.buttonCalibrateTo4.icon.iconname = "dialog-ok-apply";
      } catch(e) {
        this.buttonCalibrateTo4.icon.iconname = "process-stop";
      } finally {
        await sleep(3000);
        this.buttonCalibrateTo4.icon.iconname = "dialog-ok";
        this.buttonCalibrateTo4.style.pointerEvents = "";
      }
	}
	async buttonCalibrateTo10_click() {
      try {
        this.buttonCalibrateTo10.style.pointerEvents = "none";
        this.buttonCalibrateTo10.icon.iconname = "view-refresh";
        await server.rcall("RM_ezoph_calibrateTo10");
        this.buttonCalibrateTo10.icon.iconname = "dialog-ok-apply";
      } catch(e) {
        this.buttonCalibrateTo10.icon.iconname = "process-stop";
      } finally {
        await sleep(3000);
        this.buttonCalibrateTo10.icon.iconname = "dialog-ok";
        this.buttonCalibrateTo10.style.pointerEvents = "";
      }
	}  
	onupdatedevices_handler(event) {
		var devices = event.detail;

		this.textboxDeviceID.value = devices.ezophSensor.id;
		this.textboxDeviceStatus.value = devices.ezophSensor.status;
		this.textboxValue.value = devices.ezophSensor.value;
		this.textboxCalibrationStatus.value = devices.ezophSensor.calibrationStatus;
        this.textboxSlope.value = devices.ezophSensor.slope;
	}
	buttonClose_click(event) {
		this.close();
	}
	close() {
		super.close();
	}
}

ConfigEZOPHDialog.constructor();

export default ConfigEZOPHDialog;